// hooks/useLocationTime.ts

import { useEffect, useState } from "react";
import { format, toZonedTime } from "date-fns-tz";

export const fetchCityFromCoordinates = async (
  latitude: number,
  longitude: number
): Promise<string> => {
  const response = await fetch(
    `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
  );

  if (!response.ok) {
    throw new Error("Failed to fetch city data");
  }

  const data = await response.json();
  return (
    data.address.city ||
    data.address.town ||
    data.address.village ||
    "Unknown City"
  ); // Get city, town, or village name
};

export const fetchTimezoneForCoordinates = async (
  latitude: number,
  longitude: number
): Promise<string> => {
  const response = await fetch(`http://worldtimeapi.org/api/ip`);
  const timezoneData = await response.json();
  return timezoneData.timezone; // Return the timezone
};

export const useLocationTime = (latitude: number, longitude: number) => {
  const [city, setCity] = useState<string>("");
  const [currentHour, setCurrentHour] = useState<string>("");
  const [isNight, setIsNight] = useState<boolean>(false);

  useEffect(() => {
    const getLocationTime = async () => {
      try {
        const fetchedCity = await fetchCityFromCoordinates(latitude, longitude);
        const timezone = await fetchTimezoneForCoordinates(latitude, longitude);

        // Create a Date object for the current time
        const now = new Date();

        // Convert the current time to the local time of the provided timezone
        const localTime = format(toZonedTime(now, timezone), "HH:mm");

        setCity(fetchedCity);
        setCurrentHour(localTime);
        setIsNight(
          parseInt(localTime.split(":")[0], 10) >= 18 ||
            parseInt(localTime.split(":")[0], 10) <= 6
        );
      } catch (error) {
        console.error(error);
      }
    };

    getLocationTime();
  }, [latitude, longitude]);

  return { city, currentHour, isNight };
};
